export default "__VITE_ASSET__tG96lOfw__"